import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SpinnerService } from 'app/services/spinner.service';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { DocumentService } from 'app/services/document.service';
import { UserService } from 'app/services/user/user.service';
import { UploadClientDocType, UploadClientDocTypeValues } from 'app/components/models/document';

@Component({
  selector: 'app-create-document',
  templateUrl: './create-document.component.html',
  styleUrls: ['./create-document.component.css'],
})
export class CreateDocumentComponent implements OnInit {

  submitted = false;
  error = false;
  file_error = false;
  file_message = '';
  success = false;
  dataJSON: any;
  documentForm: FormGroup;
  userList = [];
  typeList : UploadClientDocType[] = UploadClientDocTypeValues;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private documentService: DocumentService,
    private spinnerService: SpinnerService,
    private commonUtilService: CommonUtilService,
    private userService: UserService) {
  }

  ngOnInit() {
    this.spinnerService.start();

    this.commonUtilService.translateLang("HRWE.PAGE_TITLE.CREATE_DOCUMENT");

    this.documentForm = this.createDocumentFormBuilder(this.formBuilder);

    this.userService.getAllClienteList().subscribe(data => {
      this.userList = data;
      /* console.log(this.userList); */
      this.spinnerService.stop();
    });

  }

  get f() { return this.documentForm.controls; }

  get val() { return this.documentForm.value; }

  createDocumentFormBuilder(formBuilder: FormBuilder) {
    return formBuilder.group({
      selectUser: ['', [Validators.required]],
      documentType: ['', [Validators.required]],
      optionalAttachment: [''],
      documentName: ['', [Validators.required]],
      documentDesc: ['', [Validators.required]]
    });
  }

  onSubmit() {
    this.submitted = true;

    if (this.documentForm.invalid) {
      this.commonUtilService.findInvalidControls(this.documentForm);
      return;
    }
    this.spinnerService.start();

    this.dataJSON = {
      hrUser: this.val.selectUser,
      type: this.val.documentType,
      optionalFile: {
        name: this.val.optionalAttachment.name,
        fileBinary: this.val.optionalAttachment.fileBinary
      },
      name: this.val.documentName,
      description: this.val.documentDesc
    };
    console.log(this.dataJSON);

    this.save(this.dataJSON);

  }

  save(document): void {
    if (!document) { return; }
    this.documentService.addDocument(document).subscribe(data => {
      this.success = true;
      this.spinnerService.stop();
      this.goBack();
    }, err => {
      this.error = true;
      this.spinnerService.stop();
    });
  }

  goBack() {
    this.router.navigate(['/file/list']);
  }

  onFileChange(event, field, extension?) {
    const reader = new FileReader();
    if (event.target.files.length > 0) {
      this.file_error = false;
      this.file_message = '';
      const file = event.target.files[0];
      if (!extension || this.commonUtilService.enabledExtension(file, extension)) {
        reader.readAsDataURL(file);
        reader.onload = () => {
          let kb = file.size / 1024;
          let mb = kb / 1024;
          let sizeParsed = parseFloat(mb.toString());
          if (sizeParsed > CommonUtilService.LIMIT_SIZE_MB) {
            this.file_error = true;
            this.documentForm.get(field).setValue(undefined);
            return;
          }
          /* console.log(this.assistenzaForm); */
          this.documentForm.get(field).setValue({
            name: file.name,
            filetype: file.type,
            fileBinary: reader.result
          });
        };
      } else {
        this.file_message = CommonUtilService.FILE_BAD_EXTENSION;
        this.file_error = true;
        this.documentForm.get(field).setValue(undefined);
        return;
      }
    }
  }

}
